import {action} from 'mobx';

import {i18n} from '@yourcoach/i18n';

import type {Nullable} from '../../../utils/utility-types';
import type {Tracker} from '../stores/types';

import {
  getFoodDiaryTrackerTitle,
  getFoodDiaryTrackerUnitString,
} from '../../../utils/entity/foodDiary';
import {createTextInputField} from '../../../utils/validation';

export const createTrackerTextInputField = (
  tracker: Tracker & {unit?: string},
) => {
  const field = createTextInputField(tracker.slug, {
    customValidate: action(value => {
      let isValid = true;
      let error: Nullable<string> = null;

      const floatValue = parseFloat(value);

      switch (true) {
        // TODO: Make the max value depend on the tracker
        case floatValue > 20000:
          error = i18n.t('shared:max_tracker_goal', {
            tracker: getFoodDiaryTrackerTitle(tracker.slug),
            units: getFoodDiaryTrackerUnitString(tracker.unit),
            value: (20000).toLocaleString(),
          });
          isValid = false;
          break;
      }

      field.error = error;

      return isValid;
    }),
    defaultValue: tracker.amount ? tracker.amount.toString() : '',
    validationRule: {
      type: 'string',
    },
  });

  return field;
};
